module.exports = __webpack_public_path__ + "static/media/quote-bg.d58f16f9.png";